"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _mb = _interopRequireDefault(require("./mb"));

function SEMFreeCard(props) {
  var _a = props.style,
      style = _a === void 0 ? {} : _a,
      _b = props.type,
      type = _b === void 0 ? 'default' : _b,
      configuration = props.configuration;

  var _c = configuration || {},
      tips = _c.tips,
      _d = _c.list,
      list = _d === void 0 ? [] : _d,
      _e = _c.bulletinData,
      bulletinData = _e === void 0 ? {} : _e;

  var _f = bulletinData || {},
      title = _f.title,
      desc = _f.desc;

  var newList = list;

  if ((list === null || list === void 0 ? void 0 : list.length) > 3) {
    newList = list.slice(0, 3);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'SEM_flex-free-with-card',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-free-with-card__children'
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: 'SEM_flex-free-with-card__container'
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: (0, _classnames["default"])('flex-free-with-card__container__ul', {
      'flex-free-with-card__container__ul--default': !['cyan'].includes(type),
      'flex-free-with-card__container__ul--cyan': ['cyan'].includes(type)
    })
  }, /*#__PURE__*/_react["default"].createElement("li", {
    className: (0, _classnames["default"])('flex-free-with-card__container__actions', {
      'flex-free-with-card__container__actions--default': !['cyan'].includes(type),
      'flex-free-with-card__container__actions--cyan': ['cyan'].includes(type)
    })
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: 'sme_content-txt--center'
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: 'span1'
  }, title), /*#__PURE__*/_react["default"].createElement("span", {
    className: 'span2'
  }, desc))), newList === null || newList === void 0 ? void 0 : newList.map(function (item, index) {
    var _a = item || {},
        txt = _a.txt,
        num = _a.num,
        desc = _a.desc;

    if (!num) return null;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index,
      className: (0, _classnames["default"])('flex-free-with-card__container__ul__after', {
        'flex-free-with-card__container__ul__after--default': !['cyan'].includes(type),
        'flex-free-with-card__container__ul__after--cyan': ['cyan'].includes(type)
      })
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'article-content'
    }, desc), /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('blue-title', {
        'blue-title--default': !['cyan'].includes(type),
        'blue-title--cyan': ['cyan'].includes(type)
      })
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'span-txt'
    }, txt), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'span-num'
    }, num))));
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('sme-free-tips', {
      'sme-free-tips--cyan': ['cyan'].includes(type)
    })
  }, "\uFF08", tips, "\uFF09"))), /*#__PURE__*/_react["default"].createElement(_mb["default"], {
    type: type,
    configuration: configuration
  })));
}

SEMFreeCard.displayName = 'SEMFreeCard';
var _default = SEMFreeCard;
exports["default"] = _default;